import api from "./api";
import i18n from "../i18n";

// Excel şablonundaki günlük harcırah satırı sayısı (sunucudaki sınırla aynı olmalı)
export const MAX_TRAVEL_DAYS = 30;

export const escapeHtml = (value) =>
  String(value ?? "").replace(/[&<>"']/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[ch]);

export const formatAmount = (value, fractionDigits = 2) =>
  typeof value === "number"
    ? value.toLocaleString(i18n.resolvedLanguage, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      })
    : "-";

const TURKISH_ASCII_MAP = { ç: "c", ğ: "g", ı: "i", ö: "o", ş: "s", ü: "u", Ç: "C", Ğ: "G", İ: "I", Ö: "O", Ş: "S", Ü: "U" };

const toAsciiSlug = (value) =>
  String(value ?? "")
    .replace(/[çğıöşüÇĞİÖŞÜ]/g, (ch) => TURKISH_ASCII_MAP[ch])
    .normalize("NFKD")
    .replace(/[^A-Za-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

// Dosya adı çeviriden ya da ham isimden türetilmez; her dilde aynı ASCII adı üretir
export const travelAllowanceFileName = (allowance, extension) => {
  const owner = toAsciiSlug(`${allowance?.owner?.name || ""} ${allowance?.owner?.surname || ""}`);
  const date = new Date().toISOString().slice(0, 10);
  return ["Harcirah_Formu", owner, date].filter(Boolean).join("_") + `.${extension}`;
};

// Rota kimlik doğrulaması istediği için dosya, Authorization başlığını gönderen api istemcisiyle indirilir
export const downloadTravelAllowanceExcel = async (allowance) => {
  const response = await api.get(`/travel-allowances/excel/${allowance._id}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", travelAllowanceFileName(allowance, "xlsx"));
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
